/**
 * The Export action of a react-admin list, for `SectionHeader export`: what
 * react-admin's `<ExportButton>` does (every record matching the current
 * filters and sort, through the list's exporter), as a plain handler so the
 * section header can render it in its own slot. Call it from a component
 * inside the list's context — a header rendered under `<ListBase>`.
 */

import { useCallback } from 'react';
import { fetchRelatedRecords, useDataProvider, useListContext, useNotify } from 'react-admin';

export const useListExport = (maxResults = 1000) => {
  const { filter, filterValues, resource, sort, exporter, total } = useListContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const onClick = useCallback(() => {
    dataProvider
      .getList(resource, {
        sort,
        filter: filter ? { ...filterValues, ...filter } : filterValues,
        pagination: { page: 1, perPage: maxResults },
      })
      .then(({ data }) => exporter && exporter(data, fetchRelatedRecords(dataProvider), dataProvider, resource))
      .catch(() => notify('ra.notification.http_error', { type: 'error' }));
  }, [dataProvider, exporter, filter, filterValues, maxResults, notify, resource, sort]);

  return { onClick, disabled: total === 0 };
};

export default useListExport;
